import React from "react";
import { formatMoney } from "./utils";
import Drawer from "./ui/Drawer";
import "./RecognitionDetails.css";

function InfoRows({ rows }) {
  return (
    <dl className="rr-info">
      {rows.map((row) => (
        <div key={row.label} className={`rr-info__row${row.total ? " is-total" : ""}`}>
          <dt>{row.label}</dt>
          <dd className={row.accent ? "is-accent" : undefined}>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}

function RecognitionDetails({ config, data, recognition, onClose, onOpenJournal }) {
  if (!recognition) return <Drawer isOpen={false} onClose={onClose} />;

  const { texts, entry } = config;
  const project = data.projectById[recognition.projectId];
  const contract = data.contractById[recognition.contractId];

  return (
    <Drawer
      isOpen
      onClose={onClose}
      themeClass={config.themeClass}
      caption={texts.detailsCaption}
      title={project.name}
      subtitle={recognition.date}
    >
      <h3 className="rr-details__section">Основные данные</h3>
      <InfoRows
        rows={[
          { label: "Дата признания", value: recognition.date },
          { label: "Проект", value: project.name },
          { label: "Организация", value: recognition.organization },
          { label: "Контрагент", value: recognition.counterparty },
          { label: "Договор", value: contract.name },
          { label: "Статья", value: recognition.article },
        ]}
      />

      <h3 className="rr-details__section">Расчет</h3>
      <InfoRows
        rows={[
          { label: "Сумма договора без НДС", value: formatMoney(recognition.contractAmount) },
          { label: "% готовности", value: `${recognition.readiness}%` },
          { label: `${texts.noun} накопительно`, value: formatMoney(recognition.cumulative) },
          { label: `${texts.noun} за предыдущие периоды`, value: formatMoney(recognition.previous) },
          {
            label: `${texts.noun} за отчетный период`,
            value: formatMoney(recognition.current),
            accent: true,
            total: true,
          },
        ]}
      />

      <h3 className="rr-details__section">Сформированная операция</h3>
      <div className="rr-operation">
        <div className="rr-operation__row">
          <span className="rr-operation__side">Дт</span>
          {entry.debit}
        </div>
        <div className="rr-operation__row">
          <span className="rr-operation__side">Кт</span>
          {entry.credit}
        </div>
        <div className="rr-operation__row rr-operation__row--amount">
          <span>Сумма</span>
          <strong>{formatMoney(recognition.current)}</strong>
        </div>
        <button type="button" className="rr-operation__link" onClick={onOpenJournal}>
          Открыть в Журнале операций
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </Drawer>
  );
}

export default RecognitionDetails;
